import React from 'react';
import { Button, Input, Popover } from 'freemium-ui';
import { t } from 'i18next';
import { CustomFilterViewContainer } from 'routes/screens/contacts/components/FilterViews/styles';
import {
  DEFAULT_FILTER_VIEW_LENGTH,
  MAX_FILTER_VIEW_LENGTH,
} from 'routes/screens/contacts/components/constants';

type FilterViewPopOversType = {
  anchorEl: HTMLDivElement | null;
  setAnchorEl: (value: HTMLDivElement | null) => void;
  filterViewName: string;
  setFilterViewName: (value: string) => void;
  saveFilterView: (value: string, isCreate: boolean) => void;
  filterViewEditAnchorEl: HTMLDivElement | null;
  setFilterViewEditAnchorEl: (value: HTMLDivElement | null) => void;
};
const FilterViewPopOvers = (props: FilterViewPopOversType) => {
  const {
    anchorEl,
    setAnchorEl,
    filterViewName,
    setFilterViewName,
    saveFilterView,
    filterViewEditAnchorEl,
    setFilterViewEditAnchorEl,
  } = props;
  return (
    <>
      <Popover
        id="filter-view-popover"
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <CustomFilterViewContainer>
          <div className="header">{t('forms.filter_view.save_view')}</div>
          <Input
            autoFocus
            defaultValue={filterViewName}
            value={filterViewName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilterViewName(e.target.value);
            }}
            maxLength={MAX_FILTER_VIEW_LENGTH}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            showCount
          />
          <div className="filter-view-options">
            <Button
              inline
              htmlType="reset"
              type="secondary"
              onClick={() => {
                setFilterViewName('');
              }}
            >
              {t('cancel')}
            </Button>
            {/* if need we can add schema for filterView validation */}
            <Button
              inline
              htmlType="submit"
              disabled={
                filterViewName.trim().length < DEFAULT_FILTER_VIEW_LENGTH
              }
              onClick={() => {
                saveFilterView(filterViewName, true);
                setFilterViewName('');
              }}
            >
              {t('save')}
            </Button>
          </div>
        </CustomFilterViewContainer>
      </Popover>

      <Popover
        id="filter-view-edit-popover"
        anchorEl={filterViewEditAnchorEl}
        onClose={() => {
          setFilterViewEditAnchorEl(null);
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <CustomFilterViewContainer>
          <div className="header">{t('edit')}</div>
          <Input
            autoFocus
            defaultValue={filterViewName}
            value={filterViewName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilterViewName(e.target.value);
            }}
            maxLength={MAX_FILTER_VIEW_LENGTH}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            showCount
          />
          <div className="filter-view-options">
            <Button
              inline
              htmlType="reset"
              type="secondary"
              onClick={() => {
                setFilterViewName('');
              }}
            >
              {t('cancel')}
            </Button>
            {/* if need we can add schema for filterView validation */}
            <Button
              inline
              htmlType="submit"
              disabled={
                filterViewName.trim().length < DEFAULT_FILTER_VIEW_LENGTH
              }
              onClick={() => {
                saveFilterView(filterViewName, false);
                setFilterViewName('');
              }}
            >
              {t('save')}
            </Button>
          </div>
        </CustomFilterViewContainer>
      </Popover>
    </>
  );
};

export default FilterViewPopOvers;
